// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3357":"f7e1553bb9e4a6c0","4896":"3273585bd5e962e6"}[chunkId] + ".css";
};